const LEGACY_PX_PER_MM = 3;

function finiteNumber(value, fallback = 0) {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

function mmOrLegacyPx(mmValue, legacyPxValue, fallbackMm) {
  const mm = Number(mmValue);
  if (Number.isFinite(mm)) return mm;

  const px = Number(legacyPxValue);
  if (Number.isFinite(px)) return px / LEGACY_PX_PER_MM;

  return fallbackMm;
}

export function getViewportLayoutMm(viewport = {}) {
  return {
    xMm: mmOrLegacyPx(viewport.xMm, viewport.x, 0),
    yMm: mmOrLegacyPx(viewport.yMm, viewport.y, 0),
    widthMm: Math.max(
      30,
      mmOrLegacyPx(viewport.widthMm, viewport.width, 100)
    ),
    heightMm: Math.max(
      20,
      mmOrLegacyPx(viewport.heightMm, viewport.height, 80)
    ),
  };
}

export function normalizeViewportToMm(viewport = {}) {
  const layout = getViewportLayoutMm(viewport);

  return {
    ...viewport,
    x: undefined,
    y: undefined,
    width: undefined,
    height: undefined,
    xMm: layout.xMm,
    yMm: layout.yMm,
    widthMm: layout.widthMm,
    heightMm: layout.heightMm,
  };
}

export function moveViewport(viewport, dxMm, dyMm) {
  const layout = getViewportLayoutMm(viewport);

  return {
    ...viewport,
    x: undefined,
    y: undefined,
    width: undefined,
    height: undefined,
    xMm: layout.xMm + finiteNumber(dxMm, 0),
    yMm: layout.yMm + finiteNumber(dyMm, 0),
    widthMm: layout.widthMm,
    heightMm: layout.heightMm,
  };
}

export function resizeViewport(viewport, widthMm, heightMm) {
  const layout = getViewportLayoutMm(viewport);

  return {
    ...viewport,
    x: undefined,
    y: undefined,
    width: undefined,
    height: undefined,
    xMm: layout.xMm,
    yMm: layout.yMm,
    widthMm: Math.max(30, finiteNumber(widthMm, layout.widthMm)),
    heightMm: Math.max(20, finiteNumber(heightMm, layout.heightMm)),
  };
}

export function alignViewportToGrid(viewport, gridMm = 5) {
  const layout = getViewportLayoutMm(viewport);

  return {
    ...viewport,
    x: undefined,
    y: undefined,
    width: undefined,
    height: undefined,
    xMm: Math.round(layout.xMm / gridMm) * gridMm,
    yMm: Math.round(layout.yMm / gridMm) * gridMm,
    widthMm: Math.round(layout.widthMm / gridMm) * gridMm,
    heightMm: Math.round(layout.heightMm / gridMm) * gridMm,
  };
}

export function clampViewportToSheet(viewport, sheet, marginMm = 5) {
  const paper = sheet?.paper || { widthMm: 420, heightMm: 297 };
  const layout = getViewportLayoutMm(viewport);

  const maxX = Math.max(marginMm, paper.widthMm - layout.widthMm - marginMm);
  const maxY = Math.max(marginMm, paper.heightMm - layout.heightMm - marginMm);

  return {
    ...viewport,
    x: undefined,
    y: undefined,
    width: undefined,
    height: undefined,
    xMm: Math.max(marginMm, Math.min(layout.xMm, maxX)),
    yMm: Math.max(marginMm, Math.min(layout.yMm, maxY)),
    widthMm: layout.widthMm,
    heightMm: layout.heightMm,
  };
}